import { useLang } from '@/i18n';
import { useOnceInView } from '@elem/compPage/on-the-road-power-solution/pages/product/components/US/useOnceInView';
import EcoImg from 'eco-design/base/eco-img';
import { useEffect, useState } from 'react';
import css from './index.module.scss';

interface ItfItem {
    name: string;
    text: string;
    img: [string, string];
    tip?: string;
}
const C: React.FC = () => {
    const { t } = useLang('stream.overview');
    const [enter, setEnter] = useState(false);
    const items: ItfItem[] = [
        {
            name: 'C_box1_name',
            text: 'C_box1_text',
            img: [
                'https://websiteoss.ecoflow.com/figma-uploads/1783932071901-ejo4z0-compressed-Frame%201612708066.jpg',
                'https://websiteoss.ecoflow.com/figma-uploads/1783932110392-8zwala-compressed-Frame%202094654889.jpg',
            ],
        },
        {
            name: 'C_box2_name',
            text: 'C_box2_text',
            img: [
                'https://websiteoss.ecoflow.com/figma-uploads/1783932075820-s9q0cr-compressed-Frame%201612708067.jpg',
                'https://websiteoss.ecoflow.com/figma-uploads/1783932116543-1oysj3-compressed-Frame%202094654890.jpg',
            ],
        },
        {
            name: 'C_box3_name',
            text: 'C_box3_text',
            img: [
                'https://websiteoss.ecoflow.com/figma-uploads/1783932080278-y3d0ji-compressed-Frame%201612708069.jpg',
                'https://websiteoss.ecoflow.com/figma-uploads/1783932120429-fpcgf9-compressed-Frame%202094654891.jpg',
            ],
        },
        {
            name: 'C_box4_name',
            text: 'C_box4_text',
            tip: 'C_box4_tip',
            img: [
                'https://websiteoss.ecoflow.com/figma-uploads/1783932084175-2t30xx-compressed-Frame%201612708068.jpg',
                'https://websiteoss.ecoflow.com/figma-uploads/1783932124243-sgc1q9-compressed-Frame%202094654893.jpg',
            ],
        },
    ];

    useOnceInView('.stream-nl-C .title', () => {
        document.querySelector('.stream-nl-C .title')?.classList.add('enter');
    });

    useEffect(() => {
        if (typeof window !== 'undefined') {
            AniContainer.create({
                triggerElement: '.stream-nl-C .items',
                triggerHook: 1,
                offset: '10%',
                duration: '200%',
                onEnter: () => setEnter(true),
                onLeave: () => setEnter(false),
            });
        }
    }, []);

    return (
        <div className={`${css.section} stream-nl-C GtmModuleData-section space`} id="stream-nl-C" data-section-id={'stream-nl-C'}>
            <div className="info">
                <h2 className="title ani-1">{t('C_title')}</h2>
            </div>
            <ul className={`items box ${enter ? 'enter' : ''}`}>
                {items?.map((item: ItfItem, i: number) => (
                    <li className={`item itme-${i + 1}`} key={item.name} style={{ gridArea: `a${i + 1}`, transitionDelay: enter ? `${i * 0.25}s` : '0s' }}>
                        <EcoImg className="item-img" pc={item.img[0]} pad={item.img[0]} h5={item.img[1]} alt={t('C_title')} />
                        <div className="item-info">
                            <p className="item-name">{t(item.name)}</p>
                            <p className="item-text">
                                {t.rich(item.text, {
                                    w: (tx: string) => <span className="w">{tx}</span>,
                                })}
                            </p>
                            {/* {item.tip && <p className="item-tip">{t(item.tip)}</p>} */}
                        </div>
                    </li>
                ))}
            </ul>
            <p className="box tip">{t('C_box4_tip')}</p>
        </div>
    );
};

export default C;
